module.exports = __webpack_public_path__ + "static/nojaan-cover-74a404faf6f894e5062d4c101aa0569f.jpg";